var _path, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPressKitBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0H31V27C31 29.7614 28.7614 32 26 32H3C1.34315 32 0 30.6569 0 29V8H4V0ZM6 2V25.5C6 27.9853 4.65685 30 3 30C4.10457 30 26 30 26 30C27.6569 30 29 28.6569 29 27V2H6Z",
    fill: "#00067E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 7.5,
    width: 14,
    height: 2,
    fill: "#00067E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 13,
    width: 6,
    height: 1.5,
    fill: "#00067E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 16.5,
    width: 6,
    height: 1.5,
    fill: "#00067E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 20,
    width: 6,
    height: 1.5,
    fill: "#00067E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 13,
    width: 9,
    height: 10,
    fill: "#00067E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressKitBlue);
export default __webpack_public_path__ + "static/media/press-kit-blue.9d154a2524a4e8654b0d8b49b38b0bb8.svg";
export { ForwardRef as ReactComponent };